// Department
export const apiGetAllDept = "/1.0/common/department-list"
export const apiGetAllDepartment = "/1.0/department/listAll"
export const apiCreateDepartment = "/1.0/department/create"
export const apiUpdateDepartment = id => `1.0/department/${id}/update`
export const apiGetDetailDept = id => `1.0/department/${id}/detail`
export const apiDeleteDepartment = id => `1.0/department/${id}/delete`